<template>
        <vue-basic-alert
            :duration="300"
            :closeIn="10000"
            ref="alert" />
        <main class="app-container">
            <section class="profile">
                <div class="profile__top">
                    <h2>{{ $t('profile.my_profile_title') }}</h2>
                    <router-link to="/my-profile" class="button-outline">{{$t('profile.close_edit_title')}}</router-link>
                </div>
                <div class="profile__inner">

                    <profile-left v-if="authStore.userInfo"/>
                    <div class="profile__right">
                        <PersonalData v-if="authStore.userInfo"/>
                        <CompanyData v-if="authStore.userInfo"/>
                    </div>

                    </div>
            </section>
        </main>
</template>

<script>
import Menu from "@/components/Menu";
import UserLayout from "@/layouts/UserLayout";
import {useAuthStore} from "@/stores/auth.store";
import VueBasicAlert from 'vue-basic-alert'
import {inject, ref} from "vue";
import ProfileLeft from "@/components/UserProfile/ProfileLeft";
import PersonalData from "@/components/UserProfile/PersonalData";
import CompanyData from "@/components/UserProfile/CompanyData";

export default {
    name: "MyProfileEditView",
    components: {
        CompanyData,
        PersonalData,
        ProfileLeft,
        UserLayout,
        Menu,
        VueBasicAlert,
    },
    setup() {

        const authStore = useAuthStore();
        const alert = ref();
        const tagDescription = ref('');

        //search for autocomplete
        // const getItems = (search) => {
        //     items.value =  allItems.filter(obj => Object.keys(obj).some(key => obj['name'].includes(search)));
        // }


        return  {
            authStore,
            alert,
            tagDescription,
        }
    }
}
</script>

<style scoped lang="scss">
.profile {
    .specs__add {
        cursor: pointer;
        margin-top: 10px;
    }
   .specs__form {
       select {
           width: 100%;
       }
       button {
           cursor: pointer;
       }
   }
}
.control {
    display: flex;
    flex-direction: column;
    position: relative;
    &:not(:last-of-type) {
        margin-bottom: 29px;
    }
    &__label {
        font-size: 1.6rem;
        line-height: 19px;
        margin-bottom: 8px;
        font-weight: 500;
    }
    &--input {
        input {
            height: 32px;
            background-color: #fff;
            border: 1px solid #d4d1d1;
            border-radius: 5px;
            width: 100%;
            padding: 0 10px;
            font-size: 1.6rem;
            font-family: Montserrat, sans-serif;
            outline: none;
            color: #000;
            max-width: 294px;
            &::placeholder {
                color: #d4d1d1;
                opacity: 1;
            }

            &::-ms-input-placeholder {
                color: #d4d1d1;
            }
            &.error {
                border-color: #ed685b;
            }
        }
    }
    &--text {
        textarea {
            border: 1px solid #d4d1d1;
            border-radius: 5px;
            resize: none;
            height: 175px;
            width: 100%;
            font-family: Montserrat, sans-serif;
            padding: 12px;
            font-size: 1.5rem;
            line-height: 19px;
        }
    }
    &--password {
        position: relative;
        .control__eye {
            background-color: transparent;
            border: none;
            box-shadow: none;
            position: absolute;
            right: 19px;
            bottom: 16px;
            padding: 0;
            height: 24px;
        }
    }
    &--check {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: row;
        label {
            max-width: calc(100% - 42px);
            margin-bottom: 0;
            a {
                text-decoration: underline;
                font-weight: 500;
                color: black;
            }
        }
        input {
            appearance: none;
            margin-right: 23px;
            position: relative;
            &::before {
                content: "";
                display: block;
                width: 14px;
                height: 14px;
                border-radius: 2px;
                border: 2px solid #00000099;
                transition: all ease 500ms;
            }

            &::after {
                position: absolute;
                content: "";
                display: block;
                left: 5px;
                top: 1px;
                width: 5px;
                height: 10px;
                border: solid white;
                border-width: 0 3px 3px 0;
                transform: rotate(45deg);
                opacity: 0;
                transition: opacity ease 500ms;
            }
            &:checked {
                &::before {
                    border-color: #9e5d57;
                    background-color: #9e5d57;
                }
                &::after {
                    opacity: 1;
                }
            }
        }
    }
}

</style>